import { useMemo, useState } from "react";
import "./FilterGSportkampen.scss";
import { FilterDropdownGSportkampen } from "./FilterDropdownGSportkampen";

/**
 * Filter header component for G-sportkampen with controlled dropdowns.
 * Supports dynamic filter option updates from parent component.
 */
export const FilterGSportkampen = ({ filter, amount, dictionary, onChange }) => {
  const [open, setOpen] = useState(filter?.showAlways ?? true);

  const filters = useMemo(() => {
    if (!filter?.filters) return [];

    return filter.filters.map((f, i) => (
      <FilterDropdownGSportkampen
        key={`filter_gsport_${i}`}
        filter={f}
        onChange={onChange}
      />
    ));
  }, [JSON.stringify(filter?.filters), onChange]);

  if (!filter) return null;

  return (
    <header className="c-section__header">
      {!filter.hideTitle && (
        <h2 className="title">
          {amount}{" "}
          <span>
            {amount === 1 ? filter.titleSingle : filter.titlePlural}
          </span>
        </h2>
      )}
      {filter.filters && filter.filters.length > 0 && (
        <div className={`filter ${filter.hideTitle ? "noTitle" : ""}`}>
          <div className="filter-accordion ui-accordion">
            <button
              className={`float-right filter-toggle ui-accordion__toggle ${
                open ? "active" : ""
              }`}
              onClick={() => setOpen(!open)}
            >
              {dictionary?.filter || "Filter"}{" "}
              {open ? (
                <i className="fa-solid fa-caret-up"></i>
              ) : (
                <i className="fa-solid fa-caret-down"></i>
              )}
            </button>
            <div
              className={`filter-content ui-accordion__content ${
                open ? "active" : ""
              }`}
            >
              <div className="search u-clear">
                <div className="u-clear">
                  <div className="row">{filters}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};
